import Vue from 'vue';
import VueI18n, {LocaleMessages} from 'vue-i18n';

Vue.use(VueI18n);

// Contextos definidos para cada directorio de localización
const baseLocales = require.context('@/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
const abrapaLocales = require.context('@/module/integrations/abrapa/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);

// Array de contextos
const contexts: __WebpackModuleApi.RequireContext[] = [baseLocales, abrapaLocales];

function loadLocaleMessages(contexts: __WebpackModuleApi.RequireContext[] = []): LocaleMessages {
    const messages: LocaleMessages = {};

    contexts.forEach((context) => {
        context.keys().forEach((key) => {
            const matched = key.match(/([A-Za-z0-9-_]+)/i);
            if (matched && matched.length > 1) {
                const locale = matched[1];
                messages[locale] = {
                    ...messages[locale],
                    ...context(key)
                };
            }
        });
    });

    return messages;
}

const i18n = new VueI18n({
    locale: process.env.VUE_APP_I18N_LOCALE || 'en-us',
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en-us',
    silentTranslationWarn: true,
    messages: loadLocaleMessages(contexts)
});

export default i18n;
